import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../components/layout"
import TextBanner from "../components/text_banner"

import money_icon from "../assets/images/money.svg"
import paypal_icon from "../assets/images/paypal.svg"
import transfer_icon from "../assets/images/transfer.svg"

function FeesPolicies() {
  return (
    <Layout>
      <Helmet>
        <title>InTouch Counselling Services - Fees & Policies</title>
      </Helmet>

      <TextBanner h1="Fees & Policies"></TextBanner>

      <section id="wrapper">
        <section id="one" className="wrapper  style1">
          <div className="inner">
            <div className="fees">
              <p>
                Before the initial session, we will have 30-minute phone
                consultation to determine your specific, unique therapeutic
                needs and how I can be of service to you. During our phone
                consult you may ask me any questions, to help you make an inform
                decision in working together. This consultation is free of
                charge. Future bookings can be determined during the
                consultation process to ensure our schedules align.
              </p>

              <p>
                <strong>Rates:</strong> I offer telephone, online and in person
                consultations. Rates include HST:
              </p>

              <h3>Personal Therapy</h3>
              <div className="pricings">
                <div>
                  <div className="item">
                    <label>Option 1</label>

                    <h3>30 minutes </h3>
                    <h6>$55</h6>

                    <a href="/contact-us" className="button small">
                      Book now
                    </a>
                  </div>
                </div>

                <div>
                  <div className="item active">
                    <div className="recommend">recommend</div>
                    <label>Option 2</label>

                    <h3>60 minutes </h3>
                    <h6>$80</h6>

                    <a href="/contact-us" className="button small">
                      Book now
                    </a>
                  </div>
                </div>
              </div>

              <h3>Couple’s Therapy</h3>
              <div className="pricings">
                <div>
                  <div className="item">
                    <div className="recommend">recommend</div>
                    <label>Option 1</label>

                    <h3>60 minutes </h3>
                    <h6>$100</h6>

                    <a href="/contact-us" className="button small">
                      Book now
                    </a>
                  </div>
                </div>
              </div>

              <h3>Family Therapy</h3>
              <div className="pricings">
                <div>
                  <div className="item">
                    <label>Option 1</label>

                    <h3>60 minutes </h3>
                    <h6>$110</h6>

                    <a href="/contact-us" className="button small">
                      Book now
                    </a>
                  </div>
                </div>
              </div>

              <h3>Child and Young Adult Therapy</h3>
              <div className="pricings">
                <div>
                  <div className="item">
                    <label>Option 1</label>

                    <h3>30 minutes </h3>
                    <h6>$45</h6>

                    <a href="/contact-us" className="button small">
                      Book now
                    </a>
                  </div>
                </div>
                <div>
                  <div className="item">
                    <label>Option 2</label>

                    <h3>60 minutes </h3>
                    <h6>$70</h6>

                    <a href="/contact-us" className="button small">
                      Book now
                    </a>
                  </div>
                </div>
              </div>

              <p>
                Receipts will be provided upon request. I offer a sliding scale
                for those in financial need and I have allocated a percentage of
                my practice to such cases. Please contact me to inquire and I
                will advise you if this aspect of my practice is full. In a case
                like this, a waiting list is available.
              </p>
              <p>
                <strong>Cancellation Policy: </strong> A minimum of 24 hours is
                required to cancel with no financial penalty. If I do not
                receive 24 hours’ notice for cancelled appointments a full fee
                for your appointment will be required. Cancellations less than
                this time frame, for reasons other than illness or emergency,
                will be charged full rate. Please be mindful that your
                appointments are scheduled especially for you.
              </p>

              <div className="payment">
                <p> Payment is supported by</p>

                <div className="payment-flex">
                  <div>
                    <div className="item">
                      <div className="icon">
                        <img alt="" src={money_icon} />
                      </div>
                      <h6>Cash</h6>
                    </div>
                  </div>
                  <div>
                    <div className="item">
                      <div className="icon">
                        <img alt="" src={paypal_icon} />
                      </div>
                      <h6>Paypal</h6>
                    </div>
                  </div>
                  <div>
                    <div className="item">
                      <div className="icon">
                        <img alt="" src={transfer_icon} />
                      </div>
                      <h6>E-transfer</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  )
}

export default FeesPolicies
